import request from "@/utils/request";
//查询tab配置
function treeSelectConfig() {
    return request({
        url: `/api/home/articleList`,
        method: "get",
    });
}
//查询首页轮播图配置
function getColumnListConfig(id,pageNum,pageSize) {
    return request({
        url: `/api/home/articleListByCatalogueId?id=${id}&pageNum=${pageNum}&pageSize=${pageSize}`,
        method: "get",
    });
}
//查询首页轮播图配置
function articleLinkList() {
    return request({
        url: `/api/home/articleLinkList`,
        method: "get",
    });
}
//查询首页技术开发配置
function publicListConfig(id) {
    return request({
        url: `/api/home/articleListById?id=${id}`,
        method: "get",
    });
}

//查询基础信息配置
function getMessageConfig() {
    return request({
        url: `/api/home/treeCatalogueSelect`,
        method: "get",
    });
}

//查询基础信息配置
function treeCatalogueSelectConfig() {
    return request({
        url: `/api/home/treeCatalogueSelectRemoveHome`,
        method: "get",
    });
}

//查询基础信息配置
function bannerListConfig() {
    return request({
        url: `/api/home/bannerList`,
        method: "get",
    });
}

function articleSearchConfig(name,pageNum,pageSize) {
    return request({
        url: `/api/home/articleSearchList?name=${name}&pageNum=${pageNum}&pageSize=${pageSize}`,
        method: "get",
    });
}

//会员
function showMembersConfig() {
    return request({
        url: `/api/home/showMembersList`,
        method: "get",
    });
}
export { treeSelectConfig, getColumnListConfig, publicListConfig, getMessageConfig, treeCatalogueSelectConfig, bannerListConfig, articleSearchConfig, showMembersConfig,articleLinkList};
